import { useLocation, WindowLocation } from '@reach/router';
import { useEffect, useState } from 'react';

type UseCustomLocationReturn = WindowLocation<unknown> & {
    isReady: boolean;
};
export function useCustomLocation(): UseCustomLocationReturn {
    const location = useLocation();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => setIsReady(true), []);

    return {
        ...location,
        isReady,
    };
}
